import './skeleton.scss';

import LoadingSkeleton, {
  SkeletonProps as LoadingSkeletonProps,
} from 'react-loading-skeleton';

export type SkeletonProps = LoadingSkeletonProps;
export const Skeleton: React.FC<SkeletonProps> = ({ ...props }) => (
  <LoadingSkeleton {...props} />
);
